export function formatInteger(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return '—'
  return new Intl.NumberFormat('en-US').format(Math.round(n))
}

export function formatCurrency(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return '—'
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(n)
}

export function formatPercent(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return '—'
  return `${Math.round(n)}%`
}

export function attendanceTone(rate) {
  const value = Number(rate)
  if (!Number.isFinite(value)) return 'neutral'
  if (value >= 85) return 'positive'
  if (value >= 70) return 'neutral'
  return 'negative'
}

export function severityTone(severity) {
  const value = String(severity || 'info').toLowerCase()
  if (value === 'critical') return 'negative'
  if (value === 'warning') return 'warning'
  return 'neutral'
}
